import React from 'react'
import ClassNames from 'classnames'
import { SourcingProjectDetailStyled } from './styled'
import moment from 'moment'
import {
  Button,
  Modal,
  Image,
  InputTextarea,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
  Text,
  DatePickerInput,
  Breadcrumbs,
  SelectBoxPurchasingSite,
  Spinner,
} from '../../components'
import { ICONS } from '../../themes'
import {
  rfqController,
  auctionController,
  eventNewController,
  purchasingSiteController,
} from '../../apiService'
import {
  AnimatedComponents,
  localStorageService,
  MultiValue,
  ROUTE_PATH,
  STRING,
  toastActive,
  toastFail,
  ValueContainer,
} from '../../helpers'
import { dateMonDayYearTime } from '../../helpers/functions/format'
import FileDownload from 'js-file-download'
import { store } from 'store'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { map, find, isEmpty, filter, pickBy, has } from 'lodash'
import {
  pageSourcingBuyerController,
  rolesObj,
  pageSourcingBuyerDetailFormController,
  activityRoles,
} from '../../middleware'
import { companyController } from '../../apiService/index'
import Numeral from 'numeral'

const optionsSealStatus = [
  { value: 0, label: 'All Seal Status' },
  { value: 2, label: 'Awaiting Unseal' },
  { value: 3, label: 'Unsealed' },
  { value: 1, label: 'Sealed' },
  { value: 10, label: '-' },
]

export class SourcingProjectDetailContainers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      isEdit: false,
      isLoading: false,
      eventVat: 'Exclude VAT',
      startDate: undefined,
      endDate: undefined,
      businessCategory: [],
      buyerList: [],
      currency: [{ value: 'THB', label: 'THB' }],
      purchasingCompany: [],
      purchasingTypes: [],
      UOM: [],
      activeStep: 0,
      internalFile: [],
      statuses: [],
      awardStatuses: [],
      sealStatus: optionsSealStatus,
      eventTypes: [],
      modals: [
        { name: 'add-supplier', isOpen: false },
        { name: 'confirm-submit', isOpen: false },
        { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false, FullName: '', sourcing_id: '' },
        { name: 'cancel-project', isOpen: false },
      ],
      formData: {
        id: '',
        rfq_status_id: 1,
        auction_status_id: 1,
        sourcing_project_attachment_files_request: [],
        sourcingProject: {
          name: '',
          project_status_id: 1,
          project_no: '',
          createDate: '',
          project_status_name: '',
          description: '',
          cancel_reason: '',
          internal_note: '',
          target_date: '',
          estimate_budget: '',
          target_saving: 0,
          project_reference: '',
          predecessors: '',
          categories: '',
          purchasing_companies: '',
          purchasing_company_web: '',
          events: [],
        },
      },
      optionsPredecessor: [],
      eventHistories: [],
      listEvent: [],
      projectReason: [],
      isErrMsgReasonTextarea: false,
      cancelprojectreason: '',
      valueTextAreaReason: '',
      errorProjectReason: false,
      resultCancelProjectInit: [],
      isCancel: false,
      newRoundValidate: false,
      eventTypeId: '',
      eventAwardStatusAwaitingApprove: {
        status: false,
        renderOK: false,
      },
      idProject: '',
      rolesProjectDetail: null,
      workflowData: null,
      multiRolePro: [],
      baseCurrency: 'THB',
      loaderHistory: false,
    }
    this.handlersClickNewRound = this.handlersClickNewRound.bind(this)
  }
  componentDidMount() {
    const { match } = this.props
    const { params } = match
    let { idProject } = this.state
    idProject = params ? params.id : ''
    this.setState({ idProject })
    this._isMounted = true
    let copyid = this.props.location.state
    this.getMaster.getBusinessCategory()
    this.getMaster.getCurrency()
    this.getMaster.getRFQBuyerList()
    this.getMaster.getEventStatus()
    this.getMaster.getEventAwardStatus()
    this.getMaster.getEventTypes()
    this.getMaster.getPurchasingCompany()
    this.funcGetSourcingProjectDetail()
    this.funcGetEventListProjectDetail()
    this.funcGetPredecessor()
    this.funcGetProjectReason()
    this.funcGetNewRoundValidate()
    this.funcCheckRoles()
    const multiRolePro = activityRoles().getMultiRole()
    this.setState({ multiRolePro })
    this.getCompany()
  }
  getCompany = async () => {
    try {
      const res = await companyController().getCompany()
      if (res) {
        this.setState({
          baseCurrency: res.base_currency.name,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetNewRoundValidate() {
    let { newRoundValidate } = this.state
    const { match } = this.props
    const { id: idProject } = match.params
    const objParams = { idProject }
    try {
      const res = await rfqController().getCreateNewRoundValidate(objParams)
      const checkTF = has(res, 'data')
      if (checkTF) {
        newRoundValidate = false
        this.setState({ newRoundValidate })
      } else {
        newRoundValidate = true
        this.setState({ newRoundValidate })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetProjectReason() {
    try {
      const resProjectReason = await rfqController().getReasonSourcingProject()
      if (resProjectReason) {
        let { projectReason } = this.state
        projectReason = resProjectReason
        this.setState({ projectReason })
      }
    } catch (error) {
      console.log(error)
    }
  }
  async getWorkflow(listEvent = '') {
    let { workflowData } = this.state
    try {
      console.log('listEvent', listEvent)
      if (listEvent) {
        const funRes = map(listEvent, async (value, index) => {
          const { id, event_type_id } = value
          let obj = null
          let resFlow = await eventNewController().getApproValWorkflow(id)
          if (resFlow) {
            if (resFlow === '51510: approval work flow not found') {
              obj = {
                notFound: 'not found',
              }
              return obj
            } else {
              obj = resFlow
              return obj
            }
          }
        })
        const res = await Promise.all(funRes)
        if (res) {
          workflowData = res
          this.setState({ workflowData })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  funcCheckCompareEvent(workflowData = '', key) {
    const userIdFw = localStorage.getItem('buyerId')
    const userId = parseInt(userIdFw, 10)
    const { multiRolePro } = this.state
    const approverRole = find(multiRolePro, data => {
      return data.id === rolesObj.approver
    })
    if (workflowData && approverRole) {
      const result = workflowData[key]
      const checkTF = has(result, 'notFound')
      const checkLevels = has(result, 'levels')
      if (checkTF) {
        return false
      } else {
        if (checkLevels) {
          const { levels } = result
          const filterArrLevels = map(levels, (value, index) => {
            const { approvers } = value
            const filterId = filter(approvers, value => {
              if (
                (value.id === userId && value.status === 1) ||
                (value.id === userId && value.status === 2) ||
                (value.id === userId && value.status === 3)
              ) {
                return value
              }
            })
            return filterId[0]
          })
          const removeUndefined = filter(
            filterArrLevels,
            value => value !== undefined
          )
          if (removeUndefined.length !== 0) {
            return true
          } else {
            return false
          }
        }
      }
    } else {
      return true
    }
  }
  funcCheckRoles(user = '') {
    let { rolesProjectDetail } = this.state
    const resUserName = localStorageService.getUsersName()
    const roles = pageSourcingBuyerDetailFormController().asset(
      resUserName,
      user
    )
    const { edit } = roles
    rolesProjectDetail = edit
    this.setState({ rolesProjectDetail })
  }
  funcGetPredecessor = async () => {
    try {
      const resPredecessor = await rfqController().getPredecessor()
      const arrPredecessor = map(resPredecessor, (value, index) => {
        const { id, name } = value
        return {
          value: id,
          label: name,
        }
      })
      this.setState({ optionsPredecessor: arrPredecessor })
    } catch (error) {
      console.log(error)
    }
  }
  getMaster = {
    getBusinessCategory: async () => {
      const catBuyerId = localStorageService.getBuyerId()
      const params = {
        catBuyerId,
      }
      const businessCategory = await rfqController().getBusinessCategory(params)
      if (businessCategory) {
        let option = []
        businessCategory.map(e => {
          const data = { value: e.ID, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ businessCategory: option })
        }
      } else {
        toastFail('error')
      }
    },
    getCurrency: async () => {
      const currency = await rfqController().getCurrency()
      if (currency) {
        let option = []
        currency.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ currency: option })
        }
      } else {
        toastFail('error')
      }
    },
    getPurchasingCompany: async () => {
      const params = {
        sort_name: 'code',
        sort_by: 'asc',
      }
      const purchasingCompany = await purchasingSiteController().getPurchasingSite(
        params
      )
      if (purchasingCompany) {
        let option = []
        purchasingCompany.map(e => {
          const data = { value: e.id, label: `${e.code + ' - ' + e.name}` }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ purchasingCompany: option })
        }
      } else {
        toastFail('error')
      }
    },
    getPurchasingTypes: async () => {
      const purchasingTypes = await rfqController().getPurchasingTypes()
      if (purchasingTypes) {
        let option = []
        purchasingTypes.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ purchasingTypes: option })
        }
      } else {
        toastFail('error')
      }
    },
    getUOM: async () => {
      const UOM = await rfqController().getUOM()
      if (UOM) {
        let option = []
        UOM.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ UOM: option })
        }
      } else {
        toastFail('error')
      }
    },
    getSupplierRqf: async (searchKeywords, page, onClickSearch) => {
      let {
        suppliersRfq,
        stackSelectSuppliersRfq,
        paginationSupplierlist,
      } = this.state
      const params = {
        search: searchKeywords,
        pagination: page,
      }
      if (this._isMounted) {
        this.setState({ stateSupplierRqfLoading: true })
      }
      const resSupplierRfq = await rfqController().getSupplierRfq(params)
      if (resSupplierRfq && resSupplierRfq.records) {
        paginationSupplierlist = {
          next_page: resSupplierRfq.next_page,
          page: resSupplierRfq.page,
        }
        const resSuppliersRfq = resSupplierRfq.records.map(sup => {
          return { ...sup, checked: false, disabled: false }
        })
        if (onClickSearch) {
          suppliersRfq = [...resSuppliersRfq]
        } else {
          suppliersRfq = [...suppliersRfq, ...resSuppliersRfq]
        }
        stackSelectSuppliersRfq.map(e => {
          const index = suppliersRfq.findIndex(
            sup => sup.SupplierID === e.SupplierID
          )

          const suppliersRfqDisabled = suppliersRfq.map(supRfq => {
            const selectSupplierRfqMatching =
              e.TaxID === supRfq.TaxID && e.SupplierID === supRfq.SupplierID
            const selectSupplierRfqDupplicate =
              e.TaxID === supRfq.TaxID && e.SupplierID !== supRfq.SupplierID

            if (selectSupplierRfqMatching) {
              return {
                ...supRfq,
                checked: true,
                disabled: false,
              }
            } else if (selectSupplierRfqDupplicate) {
              return { ...supRfq, disabled: true }
            } else {
              return { ...supRfq }
            }
          })
          suppliersRfq = suppliersRfqDisabled
          if (suppliersRfq[index]) {
            suppliersRfq[index].checked = true
          }
        })
        if (this._isMounted) {
          this.setState({
            paginationSupplierlist,
            suppliersRfq,
            stateSupplierRqfLoading: false,
          })
        }
      } else {
        toastFail('Not Found')
      }
    },
    getEventStatus: async () => {
      const res = await eventNewController().getEventStatus()
      if (res) {
        let option = []
        res.map(e => {
          const data = { value: parseInt(e.id), label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          return this.setState({ statuses: option })
        }
      }
    },
    getRFQBuyerList: async () => {
      const res = await rfqController().getBuyerList()
      if (res) {
        let option = []
        res.map(e => {
          const data = { value: parseInt(e.id), label: e.full_name }
          option.push(data)
        })
        if (this._isMounted) {
          return this.setState({ buyerList: option })
        }
      }
    },

    getEventAwardStatus: async () => {
      const res = await eventNewController().getEventAwardStatus()
      if (res) {
        let option = []
        res.map(e => {
          const data = { value: parseInt(e.id), label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          return this.setState({ awardStatuses: option })
        }
      }
    },
    getEventTypes: async () => {
      const res = await rfqController().getEventTypes()
      if (res) {
        let option = []
        res.map(e => {
          const data = { value: e.ID, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          return this.setState({ eventTypes: option })
        }
      }
    },
  }
  // copyRfqByID = async formData => {
  //   const { match } = this.props
  //   const { params } = match
  //   const { id, rfqid } = params
  //   const { event_type_id, event_id } = formData
  //   const objSend = {
  //     sourcing_project_request: {
  //       id,
  //     },
  //     rfq: {
  //       id: rfqid,
  //       event_type_id,
  //     },
  //   }
  //   try {
  //     const res = await rfqController().copyRfqProjectByID(objSend)
  //     if (res) {
  //       const { id: idProject, rfq_details } = res
  //       const { event_id } = rfq_details
  //       const linkCreateProject = `/sourcing-detail-form-buyer/${idProject}/${event_id}`
  //       toast.success('Copy Success')
  //       this.props.history.push(linkCreateProject)
  //     }
  //   } catch (error) {
  //     throw `copy rfq fail ${error}`
  //   }
  // }
  downloadFileSourcingProject = parmas => {
    return rfqController()
      .downloadFileSourcingProject(parmas.id)
      .then(res => FileDownload(res.data, parmas.name))
  }
  downloadFileExcelDetail = (id, name, event_type_id) => {
    if (event_type_id === 1) {
      return rfqController()
        .downloadCompareToExcel(id)
        .then(res => FileDownload(res.data, name + '.xlsx'))
    }
    if (event_type_id === 2) {
      return auctionController()
        .downloadCompareToExcel(id)
        .then(res => FileDownload(res.data, name + '.xlsx'))
    }
  }
  getInternalFileById = async id => {
    let { internalFile } = this.state
    const res = await rfqController().getInternalFileProject(id)
    if (res) {
      internalFile = res
      this.setState(internalFile)
      if (this._isMounted) {
        this.setState({ isEdit: true, internalFile })
      }
    } else {
      toastFail('error')
    }
  }

  matchValueSelected = (option, selectedId) => {
    let result = find(
      option,
      (v, k) => v.value.toString() === selectedId.toString()
    )
    return result
  }

  matchValue = (option, selectedId) => {
    const matchOption = option.find(
      value => value.value.toString() === selectedId.toString()
    )
    if (matchOption) {
      return matchOption.label
    }
  }

  matchLabel = (option, selectedLabel) => {
    const matchOption = option.find(value => value.label === selectedLabel)
    if (matchOption) {
      return matchOption.value
    }
  }

  matchValueSealStatus = (option, selectedLabel) => {
    const matchOption = option.find(value => value.label === selectedLabel)
    if (matchOption) {
      return matchOption.label
    }
  }
  renderSealStatusText = (options, values) => {
    const objectText = {
      awaiting: 'Awaiting Unseal',
      unsealed: 'Unsealed',
      sealed: 'Sealed',
    }
    if (values) {
      if (values === objectText.awaiting) {
        return (
          <React.Fragment>
            <p className="seal-status-awaiting">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.unsealed) {
        return (
          <React.Fragment>
            <p className="seal-status-unsealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      } else if (values === objectText.sealed) {
        return (
          <React.Fragment>
            <p className="seal-status-sealed">
              {this.matchValueSealStatus(options, values)}
            </p>
          </React.Fragment>
        )
      }
    } else {
      return '-'
    }
  }
  renderIconExport = (data, rolesTec) => {
    const rolesCheck = activityRoles().checkMultiRole(
      true,
      'export',
      'sourcing-project-detail'
    )
    const {
      seal_status_name,
      seal_status,
      is_cancel,
      rfq_status_id,
      auction_status_id,
      id,
      name,
      event_type_id,
    } = data
    const status_id = rfq_status_id || auction_status_id
    const renderExport = () => {
      if (
        seal_status_name !== '' &&
        status_id === 4 &&
        seal_status_name !== 'Awaiting Unseal' &&
        seal_status_name !== 'Sealed'
      ) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={e => {
                if (e.detail === 1) {
                  return this.downloadFileExcelDetail(id, name, event_type_id)
                }
                // this.downloadCompareToExcel(data)
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (
        seal_status_name !== '' &&
        status_id === 5 &&
        seal_status_name !== 'Awaiting Unseal' &&
        seal_status_name !== 'Sealed'
      ) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={e => {
                if (e.detail === 1) {
                  return this.downloadFileExcelDetail(id, name, event_type_id)
                }
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (seal_status_name == '' && status_id === 4) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={e => {
                if (e.detail === 1) {
                  return this.downloadFileExcelDetail(id, name, event_type_id)
                }
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (seal_status_name == '' && status_id === 5) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={e => {
                if (e.detail === 1) {
                  return this.downloadFileExcelDetail(id, name, event_type_id)
                }
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      } else if (seal_status_name == '' && is_cancel === true) {
        return (
          <React.Fragment>
            <Button
              className="link"
              onClick={e => {
                if (e.detail === 1) {
                  return this.downloadFileExcelDetail(id, name, event_type_id)
                }
              }}
            >
              <Image
                className="export-icon"
                src={ICONS['icon-export.svg']}
                alt="export"
                tootipValue={`Export`}
                useTootipFor="Export"
                useTootip={true}
              />
            </Button>
          </React.Fragment>
        )
      }
    }
    if (rolesCheck) {
      return renderExport()
    }
  }

  funcCheckProjectStatus = id => {
    let statusName = ''
    switch (id) {
      case 1: {
        statusName = 'Draft'
        return statusName
      }
      case 2: {
        statusName = 'WIP'
        return statusName
      }
      case 3: {
        statusName = 'Cancelled'
        return statusName
      }
      case 4: {
        statusName = 'Completed'
        return statusName
      }
      default:
        break
    }
  }
  funcGetSourcingProjectDetail = async () => {
    let { formData, resultCancelProjectInit, isCancel } = this.state
    const { match } = this.props
    const { id, eventid } = match.params
    const obj = {
      id,
      eventId: eventid ? eventid : '',
    }
    try {
      if (id) {
        await this.getInternalFileById(id)
        // const res = await rfqController().getSourcingProject(obj)
        const res = await eventNewController().getProjectBuyer(id)
        if (res) {
          const {
            project_no,
            project_status_id,
            name,
            created_at,
            created_by,
            created_by_id,
            cancel_reason,
            description,
            estimate_budget,
            target_saving,
            categories,
            predecessors,
            project_reference,
            internal_note,
            purchasing_companies,
            id,
            target_date,
            events,
            is_cancel,
          } = res
          isCancel = is_cancel
          const mapEvent = map(events, async (value, index) => {
            const { id: idProject } = match.params
            const { ID: eventId } = value
            const obj = {
              id: idProject,
              eventId,
            }
            // const eventRes = await rfqController().getSourcingProject(obj)
            const eventRes = await eventNewController().getEventListProjectBuyer(
              id
            )
            console.log({ eventRes })
            try {
              if (eventRes) {
                const { rfq_details, auction_details } = eventRes
                if (auction_details) {
                  return auction_details
                }
                if (rfq_details) {
                  return rfq_details
                }
              }
            } catch (error) {
              console.log(error)
            }
          })
          // const resEventRfq = async () => {
          //   const results = await Promise.all(mapEvent)
          //   let { listEvent } = this.state
          //   listEvent = results
          //   this.getWorkflow(results)
          //   this.setState({
          //     listEvent,
          //   })
          // }
          // resEventRfq()
          const valuePurchasingCompanies = map(purchasing_companies, (v, k) => {
            return {
              value: v.id,
              label: v.name,
            }
          })
          const { sourcingProject } = formData
          sourcingProject.defaultPurchasingCompanies = { value: '', label: '-' }
          formData.id = id
          sourcingProject.project_no = project_no
          sourcingProject.project_status_id = project_status_id
          const projectStatusName = this.funcCheckProjectStatus(
            project_status_id
          )
          sourcingProject.project_status_name = projectStatusName
          sourcingProject.name = name
          sourcingProject.created_at = moment(created_at).format(
            'MMM DD, YYYY hh:mm A'
          )
          // sourcingProject.created_by = await this.matchValueSelected(
          //   this.state.buyerList,
          //   created_by
          // )
          sourcingProject.created_by = created_by
          sourcingProject.created_by_id = created_by_id
          sourcingProject.cancel_reason = cancel_reason
          sourcingProject.description = description
          sourcingProject.estimate_budget = estimate_budget
          sourcingProject.target_saving = target_saving
          const objCategories = {
            value: categories ? categories.ID : '',
            label: categories ? categories.name : '-',
          }
          const objPredecessor = {
            value: predecessors ? predecessors.id : '',
            label: predecessors ? predecessors.name : '-',
          }
          sourcingProject.categories = objCategories
          sourcingProject.predecessor = objPredecessor
          sourcingProject.project_reference = project_reference
          sourcingProject.internal_note = internal_note
          sourcingProject.purchasing_companies = valuePurchasingCompanies
          if (target_date) {
            const time = target_date
            let IsoDateTo = moment(time, 'YYYY/MM/DD HH:mm:ss').toDate()
            sourcingProject.target_date = new Date(IsoDateTo)
          }
          // if (target_date) {
          //   sourcingProject.target_date = new Date(target_date)
          // }
          sourcingProject.events = events
          resultCancelProjectInit = res
          this.setState({ id, formData, resultCancelProjectInit, isCancel })
        }
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        toast.dismiss()
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      }, 800)
    }
  }

  funcGetEventListProjectDetail = async () => {
    let { formData, resultCancelProjectInit, isCancel, listEvent } = this.state
    const { match } = this.props
    const { id } = match.params

    let res = await eventNewController().getEventListProjectBuyer(id)
    console.log({ res })
    try {
      if (res) {
        console.log({ res })
        this.setState({ listEvent: res })
      }
    } catch {
      setTimeout(() => {
        toast.dismiss()
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      }, 800)
    }
  }
  downloadInternal = (filesId = '', filesName = '') => {
    if (filesId && filesName) {
      return rfqController()
        .downloadFileSourcingProject(filesId)
        .then(res => {
          return FileDownload(res.data, filesName)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
  toggleModal = (evt, name, sourcing_id) => {
    if (this._isMounted) {
      return this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
          FullName: name,
          sourcing_id: sourcing_id,
        })),
      }))
    }
  }

  renderStartDateEndDate = (date = {}) => {
    return (
      <Section>
        ( Start date: {dateMonDayYearTime(date.start_date)}
        <br />
        End date: {dateMonDayYearTime(date.end_date)} )
      </Section>
    )
  }
  rfqHistoryReopenRescheduleShowStartDateEndDate = (rh = {}) => {
    const reOpen = rh.action_history_type_id === 11
    const reSchedule = rh.action_history_type_id === 12
    if (reOpen || reSchedule) {
      const date = {
        start_date: rh.start_date,
        end_date: rh.end_date,
      }
      return this.renderStartDateEndDate(date)
    }
  }
  listRole = (roles = []) => {
    if (roles.length > 0) {
      return (
        <React.Fragment>
          <div>
            {roles.map((v, i) => {
              return <p key={v.id}>{v.name}</p>
            })}
          </div>
        </React.Fragment>
      )
    }
  }
  renderEventHistories() {
    const { eventHistories } = this.state
    if (eventHistories) {
      return eventHistories.map((rh, i) => {
        const reject = rh.action_history_type_id === 9
        const isSupplierAccount = rh.by_main_role_id === 3
        const isSystemReject = rh.action_history_type.includes('Reject')
          ? rh.roles.findIndex(r => r.name === 'System') > -1
            ? true
            : false
          : false
        const funcRenderActionHistoryType = () => {
          if (rh.action_history_type.includes('Reject') && !isSystemReject) {
            return <Section>Reason: {rh.cancel_reason}</Section>
          } else {
            return ''
          }
        }
        return (
          <Table.TR key={i}>
            <Table.TD className="create-date">
              {dateMonDayYearTime(rh.created_at)}
            </Table.TD>
            <Table.TD className="detail">
              <Section>{rh.action_history_type}</Section>
              {funcRenderActionHistoryType()}
              {this.rfqHistoryReopenRescheduleShowStartDateEndDate(rh)}
            </Table.TD>
            <Table.TD className="action">
              <Section> {rh.action_by}</Section>
              <Section>
                {isSupplierAccount
                  ? rh.supplier_company_name
                  : this.listRole(rh.roles)}
              </Section>
            </Table.TD>
          </Table.TR>
        )
      })
    }
  }
  async onClickOpenRfqHistory(e) {
    this.setState({ loaderHistory: true })
    const { id, event_id } = e
    try {
      let res = await eventNewController().eventHistories(id)
      if (res) {
        if (this._isMounted) {
          this.setState({ eventHistories: res, loaderHistory: false })
        }
        this.toggleModal('history')
      }
    } catch (error) {
      console.log(error)
    }
  }
  funcListEvent = () => {
    let {
      formData,
      eventsList,
      eventTypes,
      statuses,
      awardStatuses,
      buyerList,
      listEvent,
    } = this.state
    const listEvents = listEvent
    const idRoleTec = 10
    const someArrayCheckRole = element => {
      return element.id !== idRoleTec
    }
    let hideTecRole = null
    const checkEmptyRole = isEmpty(this.props.user)
    if (checkEmptyRole === false) {
      hideTecRole = this.props.user.roles.some(someArrayCheckRole)
    }
    if (listEvents.length !== 0) {
      const funcGetEventType = e => {
        if (e.event_type) {
          return this.matchValue(eventTypes, e.event_type)
        } else {
          return null
        }
      }
      const funcStartDate = e => {
        if (e.start_date === '0001-01-01T00:00:00Z' || e.start_date === '') {
          return 'N/A'
        } else {
          const setTimeStartDate = e.start_date
            ? moment(e.start_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          // return dateMonDayYearTime(setTimeStartDate)
          return dateMonDayYearTime(e.start_date)
        }
      }
      const funcEndDate = e => {
        if (e.end_date === '0001-01-01T00:00:00Z' || e.end_date === '') {
          return 'N/A'
        } else {
          const setTimeEndDate = e.end_date
            ? moment(e.end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          // return dateMonDayYearTime(setTimeEndDate)
          return dateMonDayYearTime(e.end_date)
        }
      }
      const funcActiveStatus = e => {
        const { rfq_status_id, auction_status_id, is_cancel, status } = e
        if (is_cancel) {
          return <p className={`inactive-status`}>Cancelled</p>
        } else {
          if (rfq_status_id) {
            return (
              <p
                className={
                  rfq_status_id === 1 || rfq_status_id === 2
                    ? `pending-status`
                    : rfq_status_id === 3
                    ? `success-status`
                    : `info-status`
                }
              >
                {this.matchValue(statuses, rfq_status_id)}
              </p>
            )
          } else if (auction_status_id) {
            return (
              <p
                className={
                  auction_status_id === 1 || auction_status_id === 2
                    ? `pending-status`
                    : auction_status_id === 3
                    ? `success-status`
                    : `info-status`
                }
              >
                {this.matchValue(statuses, auction_status_id)}
              </p>
            )
          } else if (status) {
            return (
              <p
                className={
                  status === 1 || status === 2
                    ? `pending-status`
                    : status === 3
                    ? `success-status`
                    : `info-status`
                }
              >
                {this.matchValue(statuses, status)}
              </p>
            )
          } else {
            return null
          }
        }
      }
      const funcAwardStatus = e => {
        const { rfq_award_status_id, auction_award_status_id } = e
        if (rfq_award_status_id && rfq_award_status_id != 0) {
          return (
            <p
              className={
                rfq_award_status_id === 1
                  ? ``
                  : rfq_award_status_id === 3 || rfq_award_status_id === 4
                  ? `pending-status`
                  : rfq_award_status_id === 2 || rfq_award_status_id === 5
                  ? `info-status`
                  : rfq_award_status_id === 6
                  ? `success-status`
                  : rfq_award_status_id === 7 && `rejected-status`
              }
            >
              {this.matchValue(awardStatuses, rfq_award_status_id)}
            </p>
          )
        } else if (auction_award_status_id && auction_award_status_id != 0) {
          return (
            <p
              className={
                auction_award_status_id === 1
                  ? ``
                  : auction_award_status_id === 3 ||
                    auction_award_status_id === 4
                  ? `pending-status`
                  : auction_award_status_id === 2 ||
                    auction_award_status_id === 5
                  ? `info-status`
                  : auction_award_status_id === 6
                  ? `success-status`
                  : auction_award_status_id === 7 && `rejected-status`
              }
            >
              {this.matchValue(awardStatuses, auction_award_status_id)}
            </p>
          )
        } else {
          return 'N/A'
        }
      }

      const funcGetEventName = e => {
        const { eventsList } = this.state
      }
      const funcGetBuyerName = e => {
        if (e.created_by) {
          return this.matchValue(buyerList, e.created_by)
        } else {
          return null
        }
      }
      const actionsEdit = e => {
        const rolesCheck = activityRoles().checkMultiRole(
          true,
          'edit',
          'sourcing-project-detail'
        )
        const { id: idProject } = this.props.match.params
        const { formData } = this.state
        const {
          rfq_status_id,
          auction_status_id,
          sourcing_project_id,
          event_id,
        } = e
        const linkEdit = `/sourcing-detail-form-events-buyer/${idProject}/${event_id}`
        const renderButton = () => {
          const handlerClickEdit = e => {
            localStorage.setItem('isFromDetail', true)
            if (e.detail === 1) {
              return this.props.history.push(linkEdit)
            }
          }
          if (rolesCheck && formData.sourcingProject.project_status_id !== 4) {
            return (
              <Button className="link" onClick={handlerClickEdit}>
                <Image
                  className="edit-icon"
                  src={ICONS['icon-edit.svg']}
                  alt="View/Edit"
                  tootipValue={`View/Edit`}
                  useTootipFor="View/Edit"
                  useTootip={true}
                />
              </Button>
            )
          }
        }
        if (rfq_status_id === 1 || auction_status_id === 1) {
          return renderButton()
        }
      }
      const actionscompareEvent = (e, key) => {
        const { id, event_type } = e
        const { idProject, workflowData } = this.state
        const resCheckCompare = this.funcCheckCompareEvent(workflowData, key)
        const rolesCheck = activityRoles().checkMultiRole(
          resCheckCompare,
          'compare',
          'sourcing-project-detail'
        )

        const linkSourcingCompare = `/sourcing-compare-events/${idProject}/${id}/${event_type}`
        const { rfq_status_id, auction_status_id, status } = e
        const awaitingSelection = 3
        const awaitingUnseal = 'Awaiting Unseal'
        const awaitingButtonCompare = () => {
          if (rolesCheck) {
            return (
              <Button
                className="link"
                onClick={() => {
                  localStorage.setItem('isFromDetail', true)
                  this.props.history.push(linkSourcingCompare)
                }}
              >
                <Image
                  className="compare-icon"
                  src={ICONS['icon-compare.svg']}
                  alt="compare"
                  tootipValue={`Compare`}
                  useTootipFor="Compare"
                  useTootip={true}
                />
              </Button>
            )
          }
        }
        // if (rfq_status_id) {
        //   if (rfq_status_id !== 1) {
        //     return awaitingButtonCompare()
        //   }
        // }
        // if (auction_status_id) {
        //   if (auction_status_id !== 1) {
        //     return awaitingButtonCompare()
        //   }
        // }
        if (status) {
          if (status !== 1) {
            return awaitingButtonCompare()
          }
        }
      }
      const copyRfqByID = (e, formData, i) => {
        const { events } = formData.sourcingProject
        const { match, history } = this.props
        const { id } = match.params
        localStorage.setItem('isFromDetail', 'true1')
        // const linkCopy = `/sourcing-detail-form-buyer-cocr/${id}/${events[i].sourcing_id}`
        const linkCopy = `/sourcing-detail-form-buyer-cocr/${id}/${events[i].ID}`
        if (e.detail === 1) {
          return history.push(linkCopy)
        }
      }
      const funcCopyRfqByID = (e, i) => {
        const rolesCheck = activityRoles().checkMultiRole(
          true,
          'copy-rfq',
          'sourcing-project-detail'
        )

        if (rolesCheck) {
          return (
            <Button
              className="link"
              onClick={e => copyRfqByID(e, formData, i)}
              // onClick={e => {
              //   const objectData = {
              //     id: sourcing_project_id,
              //     rfqId: sourcing_id,
              //     eventId: event_id,
              //     eventButton: e,
              //     event_type_id,
              //   }
              //   copyRfqByID(objectData)
              // }}
            >
              <Image
                className="paste-icon"
                src={ICONS['icon-paste.svg']}
                alt="copy"
                tootipValue={`Copy`}
                useTootipFor="Copy"
                useTootip={true}
              />
            </Button>
          )
        }
      }
      const handlerActionsLinkClick = e => {
        return this.onClickOpenRfqHistory(e)
      }
      const funcRenderHistory = e => {
        const rolesCheck = activityRoles().checkMultiRole(
          true,
          'history',
          'sourcing-project-detail'
        )
        const roles = pageSourcingBuyerController().assetAwaiting()
        const multiRole = pageSourcingBuyerController().getMultiRole()
        const purchaserMultiRole = find(multiRole, data => {
          return data.id === rolesObj.purchaser
        })
        const tecMultiRole = find(multiRole, data => {
          return data.id === rolesObj.tec
        })
        if (rolesCheck) {
          return (
            <Button
              className="link"
              onClick={() => {
                handlerActionsLinkClick(e)
              }}
            >
              <Image
                className="history-icon"
                src={ICONS['icon-history.svg']}
                alt="history"
                tootipValue={`History`}
                useTootipFor="History"
                useTootip={true}
              />
            </Button>
          )
        }
      }
      const funcDelete = e => {
        const rolesCheck = activityRoles().checkMultiRole(
          true,
          'delete',
          'sourcing-project-detail'
        )
        const { rfq_status_id, auction_status_id } = e
        const renderButtonDelete = () => {
          if (rolesCheck) {
            return (
              <Button
                className="link"
                onClick={() => {
                  this.toggleModal('delete', e.name, e.id),
                    (this.listDelete = e.id)
                  document.body.classList.add('modal-open')
                }}
              >
                <Image
                  className="delete-icon"
                  src={ICONS['icon-trash.svg']}
                  alt="delete"
                  tootipValue={`Delete`}
                  useTootipFor="Delete"
                  useTootip={true}
                />
              </Button>
            )
          }
        }
        if (rfq_status_id === 1 || auction_status_id === 1) {
          return renderButtonDelete()
        }
      }
      return listEvents.map((e, i) => {
        const {
          event_no,
          event_name,
          seal_status_name,
          create_by,
          created_by,
          rfq_award_status_id,
          auction_award_status_id,
          event_type_id,
        } = e

        let { eventAwardStatusAwaitingApprove, eventTypeId } = this.state
        if (
          (rfq_award_status_id === 4 || auction_award_status_id === 4) &&
          !eventAwardStatusAwaitingApprove.status
        ) {
          eventAwardStatusAwaitingApprove.status = true
          this.setState({ eventAwardStatusAwaitingApprove })
        }
        if (listEvents.length > 0) {
          if (i === listEvents.length - 1) {
            eventAwardStatusAwaitingApprove.renderOK = true
          }
          if (i === 0 && !eventTypeId && event_type_id) {
            eventTypeId = event_type_id
            this.setState({ eventTypeId })
          }
        } else {
          eventAwardStatusAwaitingApprove.renderOK = true
        }
        const funcRenderButtonAuction = e => {
          if (e.event_type === 'Auction') {
            return (
              <Button
                className="link"
                onClick={() => {
                  this.props.history.push(`/sourcing-auction-buyer/${e.id}`)
                }}
              >
                <Image
                  className="Auction-icon"
                  src={ICONS['icon-hammer-blue.svg']}
                  alt="Auction"
                  tootipValue={`Auction`}
                  useTootipFor="Auction"
                  useTootip={true}
                />
              </Button>
            )
          } else {
            return null
          }
        }
        return (
          <Table.TR key={i}>
            <Table.TD>
              <Text tootipValue={event_no} useTootipFor="code" useTootip={true}>
                {event_no}
              </Text>
            </Table.TD>
            <Table.TD>
              <Text
                tootipValue={event_name}
                useTootipFor="sourcing-name"
                useTootip={true}
              >
                {event_name}
              </Text>
            </Table.TD>
            <Table.TD className="text-center">{funcGetEventType(e)}</Table.TD>
            <Table.TD className="text-center w-250">
              {funcStartDate(e)}
            </Table.TD>
            <Table.TD className="text-center w-250">{funcEndDate(e)}</Table.TD>
            <Table.TD className="text-center active-status">
              {funcActiveStatus(e)}
            </Table.TD>
            <Table.TD className="text-center">
              <React.Fragment>
                {this.renderSealStatusText(
                  this.state.sealStatus,
                  seal_status_name
                )}
              </React.Fragment>
            </Table.TD>
            <Table.TD className="text-center">{funcAwardStatus(e)}</Table.TD>
            <Table.TD className="text-center w-250">
              {created_by || create_by}
            </Table.TD>
            <Table.TD className="text-center actions">
              <Section>
                {e.auction_status_id === 3 && funcRenderButtonAuction(e)}
                {actionsEdit(e)}
                {actionscompareEvent(e, i)}
                {funcCopyRfqByID(e, i)}
                {funcRenderHistory(e)}
                {this.renderIconExport(e, hideTecRole)}
                {funcDelete(e)}
              </Section>
            </Table.TD>
          </Table.TR>
        )
      })
    }
  }

  onClickDelete = async id => {
    const res = await rfqController().deleteRFQ(id)
    if (res) {
      this.funcGetSourcingProjectDetail()
      this.funcGetPredecessor()
      this.funcGetProjectReason()
      this.funcGetNewRoundValidate()
      this.funcCheckRoles()
      const multiRolePro = activityRoles().getMultiRole()
      this.setState({ multiRolePro })

      toastActive('Event was delete')
      this.toggleModal()
    } else {
      toastFail('error')
    }
  }

  modalDelete() {
    const { modals } = this.state
    const funcIsOpen = () => {
      const result = this.state.modals
        .filter(modal => {
          return modal.name === 'delete'
        })
        .map(obj => obj.isOpen)[0]
      return result
    }
    const isOpenModal = funcIsOpen()

    const handlerClickCancel = e => {
      document.body.classList.remove('modal-open')
      return this.toggleModal('delete')
    }
    const handlerClickConfirm = e => {
      return this.onClickDelete(modals[0].sourcing_id)
    }
    return (
      <Modal
        id="delete_id"
        className="theme-blue"
        isOpen={isOpenModal}
        modalWidth="575px"
      >
        <Modal.Header>Delete</Modal.Header>
        <Modal.Body>
          <p className="default text-center">
            Are you sure to delete? <br />
            {modals[0].FullName}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={handlerClickCancel}
          >
            Cancel
          </Button>
          <Button
            id="close_modal_history_id"
            className="theme-green"
            onClick={handlerClickConfirm}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  modalHistoryLog() {
    const funcIsOpen = () => {
      const result = this.state.modals
        .filter(modal => {
          return modal.name === 'history'
        })
        .map(obj => obj.isOpen)[0]
      return result
    }
    const isOpenModal = funcIsOpen()
    const handlerOnClickHistory = e => {
      this.toggleModal()
      if (this._isMounted) {
        setTimeout(() => {
          this.setState({ eventHistories: [] })
        }, 600)
      }
    }
    return (
      <Modal
        id="history_log"
        className="history-log theme-blue"
        isOpen={isOpenModal}
      >
        <Modal.Header>History Log</Modal.Header>
        <Modal.Body>
          {this.state.loaderHistory ? (
            <Spinner />
          ) : (
            <Section className="table-header-freeze-wrapper">
              <Table className="history-log-data">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TH className="create-date">DATE</Table.TH>
                    <Table.TH className="detail">ACTIVITY</Table.TH>
                    <Table.TH className="action">ACTION BY</Table.TH>
                  </Table.TR>
                </Table.TBODY>
              </Table>
              <Table className="history-log-data split-row-color">
                <Table.TBODY>{this.renderEventHistories()}</Table.TBODY>
              </Table>
            </Section>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray close"
            onClick={handlerOnClickHistory}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  modalCancelProject() {
    let {
      formData,
      projectReason,
      cancelprojectreason,
      valueTextAreaReason,
      isErrMsgReasonTextarea,
      errorProjectReason,
      resultCancelProjectInit,
    } = this.state
    const { label } = cancelprojectreason
    const labelOther = 'Other, please specify - อื่นๆ กรุณาระบุ'
    const optionsProjectReason = map(projectReason, (value, index) => {
      const { id, name } = value
      return {
        value: id,
        label: name,
      }
    })
    const { sourcingProject } = formData
    const { name, project_no } = sourcingProject
    const funcIsOpen = () => {
      const result = this.state.modals
        .filter(modal => {
          return modal.name === 'cancel-project'
        })
        .map(obj => obj.isOpen)[0]
      return result
    }
    const isOpenModal = funcIsOpen()
    const handlerOnClickCancelProject = e => {
      cancelprojectreason = ''
      errorProjectReason = false
      isErrMsgReasonTextarea = false
      valueTextAreaReason = ''
      this.toggleModal()
      if (this._isMounted) {
        this.setState({
          cancelprojectreason,
          errorProjectReason,
          isErrMsgReasonTextarea,
          valueTextAreaReason,
        })
      }
    }
    const styleLabel = {
      display: 'flex',
      width: '20%',
      alignSelf: 'center',
      justifyContent: 'start',
      marginRight: '2.5em',
    }
    const onChangeOptions = e => {
      cancelprojectreason = e
      if (label === labelOther) {
        // valueTextAreaReason = ''
      }
      this.setState({ cancelprojectreason })
      if (this._isMounted) {
        this.setState({
          errorProjectReason: false,
          isErrMsgReasonTextarea: false,
        })
      }
    }

    const convertTimetoISOString = v => {
      let isDate = new Date(v)
      return isDate.toISOString()
    }

    const handlerClickConfirm = async e => {
      e.preventDefault()
      if (!e.detail || e.detail === 1) {
        if (
          cancelprojectreason === ''
          // cancelprojectreason === '' ||
          // (label === labelOther && valueTextAreaReason === '')
        ) {
          errorProjectReason = true
          if (this._isMounted) {
            this.setState({ errorProjectReason })
          }
        } else {
          if (label === labelOther && valueTextAreaReason === '') {
            this.setState({ isErrMsgReasonTextarea: true })
          } else {
            errorProjectReason = false
            isErrMsgReasonTextarea = false
            cancelprojectreason = ''
            // valueTextAreaReason = ''
            // const cancel_reason = valueTextAreaReason
            //   ? valueTextAreaReason
            //   : label !== labelOther
            //   ? label
            //   : ''
            const cancel_reason =
              label === labelOther ? valueTextAreaReason : label
            const is_cancel = true
            const resultData = resultCancelProjectInit
            const resultpickData = pickBy(resultData, (value, key) => {
              if (key !== 'categories') return value
            })

            resultpickData.created_at = convertTimetoISOString(
              resultpickData.created_at
            )
            resultpickData.target_date = convertTimetoISOString(
              resultpickData.target_date
            )
            resultpickData.updated_at = convertTimetoISOString(
              resultpickData.updated_at
            )

            const created_by_value = await this.matchLabel(
              this.state.buyerList,
              resultpickData.created_by
            )
            const updated_by_value = await this.matchLabel(
              this.state.buyerList,
              resultpickData.updated_by
            )

            resultpickData.created_by = created_by_value
            resultpickData.updated_by = updated_by_value

            const objDataSendApi = {
              ...resultpickData,
              is_cancel,
              cancel_reason,
            }

            try {
              const resApiSend = await rfqController().putCancelProject(
                objDataSendApi
              )
              if (resApiSend) {
                if (resApiSend === `52002: sourcing project status isn't WIP`) {
                  toastFail(`Sourcing project status isn't WIP`)
                  this.toggleModal()
                } else if (
                  resApiSend ===
                  `52003: cannot cancel project: some events's award status is 'Awaiting Approve`
                ) {
                  toastFail(
                    `Cannot cancel project: some events's award status is 'Awaiting Approve`
                  )
                  this.toggleModal()
                } else if (resApiSend === `50105: event is awaiting unseal`) {
                  toastFail(`Event is awaiting unseal`)
                  this.toggleModal()
                } else if (
                  resApiSend ===
                  `52004: cannot cancel project: events's status must be 'Cancelled' or 'Closed`
                ) {
                  toastFail(
                    `Cannot cancel project: events's status must be 'Cancelled' or 'Closed`
                  )
                  this.toggleModal()
                } else if (
                  resApiSend ===
                  `52015: user do not have permission to cancel sourcing project`
                ) {
                  toastFail(
                    `User do not have permission to cancel sourcing project`
                  )
                  this.toggleModal()
                } else {
                  toastActive('Sourcing Project has been Cancelled')
                  this.toggleModal()
                  this.props.history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
                  if (this._isMounted) {
                    this.setState({
                      errorProjectReason,
                      cancelprojectreason,
                      isErrMsgReasonTextarea,
                      valueTextAreaReason,
                    })
                  }
                }
              }
            } catch (error) {
              console.log('error', error)
            }
          }
        }
      }
    }
    const renderFuncTextarea = () => {
      const handlerChangeTextArea = e => {
        valueTextAreaReason = e.target.value
        this.setState({ valueTextAreaReason, isErrMsgReasonTextarea: false })
      }
      if (label === labelOther) {
        return (
          <Section
            className={`form-group ${isErrMsgReasonTextarea && 'is-error'}`}
          >
            <label></label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <InputTextarea
                  value={valueTextAreaReason}
                  onChange={handlerChangeTextArea}
                />
              </Section>
              <Section className="message">
                {isErrMsgReasonTextarea && 'This field is required'}
              </Section>
            </Section>
          </Section>
        )
      } else {
        return ''
      }
    }
    return (
      <Modal
        id="history_log"
        className="theme-blue modal-cancel-event"
        isOpen={isOpenModal}
        modalWidth="768px"
      >
        <Modal.Header>Cancel Project</Modal.Header>
        <Modal.Body>
          <Section className="form-group">
            <label>Project No:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {project_no}
              </Section>
            </Section>
          </Section>

          <Section className="form-group">
            <label>Project Name:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {name}
              </Section>
            </Section>
          </Section>

          <Section className={`form-group ${errorProjectReason && 'is-error'}`}>
            <label>Reason:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <SelectBox
                  id="active_category_filter"
                  options={optionsProjectReason}
                  placeholder="Select Reason"
                  value={cancelprojectreason}
                  onChange={onChangeOptions}
                  hideSelectedOptions={false}
                  style={{ maxWidth: 'unset' }}
                />
              </Section>
              <Section className="message">
                {errorProjectReason && 'Please specify reason'}
              </Section>
            </Section>
          </Section>
          {renderFuncTextarea()}

          {/* {errorProjectReason ? (
            <Section className="form-group">
              <label></label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Section className="message">Please specify reason</Section>
                </Section>
              </Section>
            </Section>
          ) : (
            ''
          )} */}

          {/* <Section className="form-wrapper">
            <Section className="info-wrapper">
              <Section className="section form-group">
                <label>Project No.</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    {project_no}
                  </Section>
                </Section>
              </Section>
              <Section className="section form-group">
                <label>Project Name</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">{name}</Section>
                </Section>
              </Section>
            </Section>
            <Section className="form-group">
              <label>Reason:</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBox
                    id="active_category_filter"
                    options={optionsProjectReason}
                    placeholder="Select Reason"
                    value={cancelprojectreason}
                    onChange={onChangeOptions}
                    hideSelectedOptions={false}
                    style={{ maxWidth: 'unset' }}
                  />
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
            {renderFuncTextarea()}
          </Section> */}
          {/* <Section className="form-group">
            <div style={styleLabel}>
              <label>Project No.</label>
            </div>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                {project_no}
              </Section>
            </Section>
          </Section>
          <Section className="form-group">
            <div style={styleLabel}>
              <label>Project Name</label>
            </div>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">{name}</Section>
            </Section>
          </Section>
          <Section className="form-group">
            <div style={styleLabel}>
              <label>Reason</label>
            </div>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <SelectBox
                  id="active_category_filter"
                  options={optionsProjectReason}
                  placeholder="Select Reason"
                  value={cancelprojectreason}
                  onChange={onChangeOptions}
                  hideSelectedOptions={false}
                  style={{ maxWidth: 'unset' }}
                />
              </Section>
            </Section>
          </Section>
          {renderFuncTextarea()} */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={handlerOnClickCancelProject}
          >
            Close
          </Button>
          <Button className="theme-green" onClick={handlerClickConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  handlerClickCancelProject() {
    this.toggleModal('cancel-project')
  }
  funcRenderButtonCancelProject() {
    const {
      isCancel,
      newRoundValidate,
      rolesProjectDetail,
      eventAwardStatusAwaitingApprove,
      eventTypeId,
    } = this.state

    const buyerId = localStorage.getItem('buyerId')
    const createby = this.state.formData.sourcingProject.created_by_id
      ? this.state.formData.sourcingProject.created_by_id.toString()
      : ''
    const isCreate = buyerId === createby ? true : false

    if (rolesProjectDetail !== false) {
      if (
        newRoundValidate &&
        isCancel === false &&
        !eventAwardStatusAwaitingApprove.status &&
        eventAwardStatusAwaitingApprove.renderOK &&
        this.state.formData.sourcingProject.project_status_id !== 4 &&
        isCreate
      ) {
        return (
          <Button
            className="theme-red page-button"
            onClick={() => this.handlerClickCancelProject()}
          >
            Cancel Project
          </Button>
        )
      }
    }
  }
  handlersClickNewRound(e, formData) {
    const { events } = formData.sourcingProject
    const { match, history } = this.props
    const { id } = match.params
    e.preventDefault()
    let idRfq = ''
    if (events && events.length !== 0) {
      idRfq = events[0].sourcing_id
    }
    localStorage.setItem('isFromDetail', true)
    localStorage.setItem('copy_event_rfqId', idRfq)
    const linkCreateProject = `/sourcing-detail-form-buyer-cocr/${id}`
    return history.push(linkCreateProject)
  }
  render() {
    const { purchasingCompany, formData, internalFile } = this.state
    const buyerId = localStorage.getItem('buyerId')
    const createby = formData.sourcingProject.created_by_id
      ? this.state.formData.sourcingProject.created_by_id.toString()
      : ''
    const isCreate = buyerId === createby ? true : false
    return (
      <SourcingProjectDetailStyled>
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_buyer_management"
                src={ICONS['icon-sourcing-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_buyer_management" className="title">
                Sourcing
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
        </Section>
        <Section className="main-content">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                Project Information
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Project No.</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.project_no
                              ? formData.sourcingProject.project_no
                              : ''
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label className="tooltip-upload">Project Status</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper rfq_status">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.project_status_id
                              ? formData.sourcingProject.project_status_name
                              : ''
                          }
                        ></Input>
                        {formData.sourcingProject.project_status_id === 3 && (
                          <Image
                            src={ICONS['icon-help.svg']}
                            alt="help"
                            tootipValue={formData.sourcingProject.cancel_reason}
                            useTootipFor="FileType"
                            useTootip={true}
                          />
                        )}
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Project Name</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.name
                              ? formData.sourcingProject.name
                              : ''
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Created Date</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.created_at
                              ? formData.sourcingProject.created_at
                              : ''
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Description</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          disabled={true}
                          value={
                            formData.sourcingProject.description
                              ? formData.sourcingProject.description
                              : '-'
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Estimate Budget ({this.state.baseCurrency})</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={Numeral(
                            formData.sourcingProject.estimate_budget
                          ).format('0,0.00')}
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Target Saving (%)</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          type="number"
                          min="0"
                          value={
                            formData.sourcingProject.target_saving
                              ? formData.sourcingProject.target_saving
                              : 0
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Category</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <SelectBox
                          id="active_category_filter"
                          options={this.state.businessCategory}
                          placeholder="Select Category"
                          value={formData.sourcingProject.categories}
                          isDisabled
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Target Date</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <DatePickerInput
                          selected={
                            formData.sourcingProject.target_date
                              ? formData.sourcingProject.target_date
                              : null
                          }
                          disabled={true}
                          minDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="MMM dd, yyyy"
                          dropdownMode="select"
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Predecessor</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <SelectBox
                          id="active_category_filter"
                          options={this.state.optionsPredecessor}
                          placeholder="Select Predecessor"
                          value={formData.sourcingProject.predecessor}
                          isDisabled
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Create By</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.created_by
                              ? formData.sourcingProject.created_by
                              : ''
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Project Reference</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          disabled={true}
                          value={
                            formData.sourcingProject.project_reference
                              ? formData.sourcingProject.project_reference
                              : '-'
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label>Purchasing Site</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        {formData.sourcingProject.purchasing_companies
                          .length !== 0 ? (
                          <SelectBoxPurchasingSite
                            id="purchasing_site"
                            options={purchasingCompany}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isDisabled
                            components={{
                              Option,
                              MultiValue,
                              ValueContainer,
                              AnimatedComponents,
                            }}
                            allowSelectAll={true}
                            fieldValue={
                              formData.sourcingProject.purchasing_companies
                                ? formData.sourcingProject.purchasing_companies
                                : ''
                            }
                          />
                        ) : (
                          <SelectBox
                            id="active_category_filter"
                            options={purchasingCompany}
                            placeholder="Select Purchasing Site"
                            value={
                              formData.sourcingProject
                                .defaultPurchasingCompanies
                            }
                            isDisabled
                          />
                        )}
                      </Section>
                      <Section className="message" />
                    </Section>
                  </Section>
                </Section>

                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label>Internal Note</label>
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          disabled={true}
                          value={
                            formData.sourcingProject.internal_note
                              ? formData.sourcingProject.internal_note
                              : '-'
                          }
                        />
                      </Section>
                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>

              <Section className="form-row">
                <Section className="form-col col-6 hide-mobile"></Section>
                <Section className="form-col col-6">
                  <Section className="form-group">
                    <label className="tooltip-upload">
                      Internal Attachment
                      <Section className="link tooltip-attachment">
                        <Image
                          src={ICONS['icon-help.svg']}
                          alt="help"
                          tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                          useTootipFor="FileType"
                          useTootip={true}
                        />
                      </Section>
                    </label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        {internalFile.length > 0 ? (
                          internalFile.map((e, i) => {
                            return (
                              <Section className="attached-file-list" key={i}>
                                <a
                                  target="_blank"
                                  className="file-link removable"
                                  rel="noopener noreferrer"
                                >
                                  <span
                                    onClick={() => {
                                      if (e.id) {
                                        return this.downloadInternal(
                                          e.id,
                                          e.file_name
                                        )
                                      } else {
                                        return null
                                      }
                                    }}
                                    className="file-name"
                                  >
                                    {e.file_name}
                                  </span>
                                </a>
                              </Section>
                            )
                          })
                        ) : (
                          <Section className="attached-file-list">-</Section>
                        )}
                      </Section>

                      <Section className="message"></Section>
                    </Section>
                  </Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-wrapper">
              <Section className="form-group-title">Sourcing Event</Section>
              <Section className="table-responsive table-wrapper">
                <Table className="user split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR>
                      <Table.TH id="event_no">EVENT NO.</Table.TH>
                      <Table.TH id="event_name">EVENT NAME</Table.TH>
                      <Table.TH className="text-center" id="event_type">
                        EVENT TYPE
                      </Table.TH>
                      <Table.TH className="text-center w-250" id="start_date">
                        START DATE
                      </Table.TH>
                      <Table.TH className="text-center w-250" id="end_date">
                        END DATE
                      </Table.TH>
                      <Table.TH
                        className="text-center active-status"
                        id="active_status"
                      >
                        STATUS
                      </Table.TH>
                      <Table.TH className="text-center" id="seal_status">
                        SEAL STATUS
                      </Table.TH>
                      <Table.TH className="text-center" id="award_status">
                        AWARD STATUS
                      </Table.TH>
                      <Table.TH className="text-center w-250" id="created_by">
                        CREATED BY
                      </Table.TH>
                      <Table.TH
                        className="text-center actions"
                        id="actions_header"
                      >
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>
                  <Table.TBODY>{this.funcListEvent()}</Table.TBODY>
                  {/*resultFound()*/}
                </Table>
              </Section>
              <Section className="page-button">
                {this.state.rolesProjectDetail !== false &&
                  formData.sourcingProject.project_status_id === 2 && (
                    <Section className="button-group">
                      {this.state.newRoundValidate &&
                      !this.state.eventAwardStatusAwaitingApprove.status &&
                      this.state.eventAwardStatusAwaitingApprove.renderOK &&
                      isCreate ? (
                        <Button
                          className="theme-blue page-button"
                          onClick={e => this.handlersClickNewRound(e, formData)}
                        >
                          Create New Round
                        </Button>
                      ) : (
                        ''
                      )}
                    </Section>
                  )}
                {this.funcRenderButtonCancelProject()}
                <Button
                  className="theme-border-gray page-button"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
                  }}
                >
                  Back
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
        {this.modalHistoryLog()}
        {this.modalCancelProject()}
        {this.modalDelete()}
      </SourcingProjectDetailStyled>
    )
  }
}

export const SourcingProjectDetailContainer = connect()(
  SourcingProjectDetailContainers
)
